import { JourneyIconButton } from 'ui/journey-builder/node-types/common';
import { useFlowNodes } from 'ui/traveller-journey-builder/hooks/use-nodes';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

type ActionType = 'journey_loop';

export const Node = (node: TravellerJourneyNode<ActionType>) => {
  useFlowNodes();

  return (
    <NodeContainer node={node}>
      <JourneyIconButton
        node={node}
        color={node.data.isSkipped ? 'purple40' : 'teal100'}
        isSelectable
      />
    </NodeContainer>
  );
};
